import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/clerk-react";
import type { VendorResponse } from "@pull/api-contract";
import { createApiClient } from "../api/ApiClient";

export function useVendor() {
  const { getToken } = useAuth();
  const api = createApiClient(getToken);

  return useQuery({
    queryKey: ["vendor", "me"],
    queryFn: () => api.get<VendorResponse>("/vendors/dashboard/me"),
  });
}
